import React, { useEffect } from 'react';
import { Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const Logout = () => {
  const { doLogout } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    doLogout();
    navigate('/');

  }, [doLogout, navigate]);

  return (
    <Container maxWidth="sm" sx={{ textAlign: 'center', marginTop: '50px' }}>
      <Typography variant="h4" gutterBottom>
        FDV Banc - Logout
      </Typography>
    </Container>
  );
};

export default Logout;